export default (state: any) => ({
  ...state,
  businessProfile: {
    data: {},
    isLoading: true,
    isSaving: false,
    hasError: false,
  },
});
